export default {
    updateStep(state, step) {
        state.gameOptions.currentStep = step;
    },
    saveOption(state, data) {
        const option = state.gameOptions.savedOptions.findIndex(option => option.id == data.id);

        if (option >= 0) {
            state.gameOptions.savedOptions[option] = data;
        } else {
            state.gameOptions.savedOptions.push(data);
        }
    },
    updatingOption(state, boolean) {
        state.gameOptions.isUpdatingOption = boolean;
    },
    resetOptions(state) {
        state.gameOptions.savedOptions = []
    },
    savePhases(state, data) {
        state.buildingPhases.savedMaterials.push(data);
    },
    updatePhase(state, phase) {
        state.buildingPhases.currentPhase = phase;
    },
    saveMaterial(state, {id, data}) {
        const phase = state.buildingPhases.savedMaterials.findIndex(phase => phase.id == id);

        if (phase >= 0) {
            state.buildingPhases.savedMaterials[phase].data = [];

            data.forEach(material => {
                state.buildingPhases.savedMaterials[phase].data.push(material);
            });
        }
    },
    saveVecataryModel(state, data) {
        state.model = data;
    },
    updateVectaryModelScreenshot(state, data) {
        state.modelScreenshot = data;
    },
    updateTooltips(state) {
        if (state.tooltips.active == state.tooltips.totalCount) {
            state.tooltips.seenAll = true;
            document.body.classList.remove('overlay');
        } else {
            state.tooltips.active = state.tooltips.active + 1;
        }
    },
    updateLearnMoreTooltip(state) {
        state.tooltips.learnMoreActive = false;
    },
    updateOverviewTooltips(state, data) {
        state.tooltips.overviewTooltips.push(data);
    },
    resetSavedMaterials(state) {
        state.buildingPhases.savedMaterials.forEach(phase => {
            phase.data = []
        });
    },
    saveResult(state, data) {
        state.result.rank = data.rank;
        state.result.name = data.name;
        state.result.score = data.score;
    },
    saveResultId(state, id) {
        state.result.id = id;
    },
    resetResult(state) {
        state.result.id = null;
        state.result.rank = null;
        state.result.name = null;
        state.result.score = null;
    },
    resetModel(state) {
        state.model.setVisibility('Camera', true, true);
        state.modelScreenshot = null;
    }
};
